import { render, staticRenderFns } from "./editAddress.vue?vue&type=template&id=72902d61&scoped=true&"
import script from "./editAddress.js?vue&type=script&lang=js&"
export * from "./editAddress.js?vue&type=script&lang=js&"
import style0 from "./editAddress.vue?vue&type=style&index=0&id=72902d61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72902d61",
  null
  
)

export default component.exports